<template>
  <div class="container">
    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <!-- Modales -->
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-img" title="" hide-footer id="modaldi" size="xl">
      <ModalPreviewImg :currentDocumento="currentDocumento" />
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-pdf" title="" hide-footer id="modaldf" size="xl">
      <ModalPreviewPDF :currentDocumento="currentDocumento" />
    </b-modal>
    <!-- Template -->
    <h4 class="cardD">Expediente</h4>

    <b-table ref="table" hover :fields="fieldsDocumentos" :items="cotejo.documentos">
      <template #cell(descripcion)="{ item }">
        <div v-if="item.tipo === 'Otro'">
          <div v-b-tooltip.hover :title="item.descripcion">
            {{ item.tipo + " - " + item.descripcion }}
          </div>
        </div>
        <div v-else-if="item.tipo === 'Anexo'">
          {{ "Anexo - " + item.nombre }}
        </div>
        <div v-else>
          {{ item.tipo }}
        </div>
      </template>
      <template #cell(filename)="{ item }">
        <div v-if="!item.documento">No cargado</div>
        <div v-else>
          {{ item.documento.split("/").pop() }}
        </div>
      </template>
      <template #cell(acciones)="{ item }">
        <b-button
          v-if="item.documento"
          variant="primary"
          size="sm"
          v-b-tooltip.hover
          title="Vista previa"
          @click="previewDocumento(item)"
          class="editBtn"
        >
          <b-icon-eye />
        </b-button>
        <b-button
          v-if="item.documento"
          size="sm"
          v-b-tooltip.hover
          title="Descargar"
          @click="descargarDocumento(item)"
          class="editBtn"
        >
          <b-icon-download />
        </b-button>
      </template>
    </b-table>

    <div class="mt-4">
      <div>
        <b-button class="btn-fill green-btn bottom1" size="m" @click="descargarExpedienteHandler">Descargar Expediente</b-button>
      </div>
    </div>

    <div class="mt-4">
      <div class="">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="isButtonDisabled">Continuar</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPreviewImg from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue";
import ModalPreviewPDF from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue";

import { FuncionesApi } from "@/api";
import { saveAs } from "file-saver";

export default {
  name: "ExpedienteCopiasCertificadas",

  components: {
    ModalPreviewImg,
    ModalPreviewPDF,
  },

  props: {
    cotejo: { type: Object },
  },

  computed: {
    isButtonDisabled() {
      return this.cotejo.id_estatus != 20;
    },
  },

  data() {
    return {
      fieldsDocumentos: [
        { key: "descripcion", label: "Descripción", class: "text-center" },
        { key: "filename", label: "Nombre archivo", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ],
      loading: false,
      currentDocumento: {},
    };
  },

  methods: {
    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000, //false,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    previewDocumento(item) {
      this.currentDocumento = item;
      const isCurrentDocumentImage = this.isCurrentDocumentAnImage();
      if (isCurrentDocumentImage) {
        this.$refs["documento-modal-preview-img"].show();
      } else {
        this.$refs["documento-modal-preview-pdf"].show();
      }
    },

    isCurrentDocumentAnImage() {
      let documentoSeparatedByDots = this.currentDocumento.nombre.split(".");
      let extensionDocumento = documentoSeparatedByDots[documentoSeparatedByDots.length - 1];
      const imageExtensions = ["jpg", "JPG", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "avif"];
      if (imageExtensions.includes(extensionDocumento)) {
        return true;
      }
      return false;
    },

    descargarExpedienteHandler() {
      this.descargarExpediente();
    },

    async descargarExpediente() {
      try {
        this.loading = true;

        const response = await FuncionesApi.descargarExpediente(4, this.cotejo.id);

        saveAs(response, "Expediente_" + this.cotejo.folio + ".zip");
      } catch (error) {
        console.error("Error downloading file:", error);
      } finally {
        this.loading = false;
      }
    },

    async descargarDocumento(documento) {
      try {
        this.loading = true;

        const response = await FuncionesApi.descargarDocumento(documento.id);
        const filename = documento.documento.split("/").pop();

        saveAs(response, filename);
      } catch (error) {
        console.error("Error downloading file:", error);
        this.showErrorToast("Error al descargar el archivo.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
